export default __webpack_public_path__ + "static/media/chennai.ab4eb930.jpg";